module.exports = __webpack_public_path__ + "static/media/doc (1).bc5f9db1.svg";